import React from 'react';

export const SectionCard = ({
  title,
  description,
  children,
  className = '',
  headerTitleClassName = 'text-[var(--text-dark-primary,#fff)]',
}: {
  title: string;
  description: string;
  children: React.ReactNode;
  className?: string;
  headerTitleClassName?: string;
}) => (
  <div
    className={`mb-6 overflow-hidden rounded-[var(--radi-6,12px)] border border-[var(--base-border,#3d3d3d)] bg-[var(--base-surface-2,#231f1f)] ${className}`}
  >
    <div className="p-6 sm:p-8">
      <div className="mb-6">
        <h2 className={`text-lg font-semibold ${headerTitleClassName}`}>{title}</h2>
        <p className="mt-1 text-sm text-[var(--text-dark-secondary,rgba(255,255,255,0.7))]">
          {description}
        </p>
      </div>
      <div className="flex flex-col">{children}</div>
    </div>
  </div>
);
